"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interpret;
exports.buildLineRule = buildLineRule;
exports.buildLabelRule = buildLabelRule;
exports.combineLabelRules = combineLabelRules;
exports.getRuleBuilderForRule = void 0;

var _atom = require("../../utils/atom");

function interpret() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return combineLabelRules(rules.map(function (rule) {
    return buildLineRule(rule);
  }));
}

var ruleBuilderDispatch = {
  label: buildLabelRule
};
var getRuleBuilderForRule = (0, _atom.makeRuleBuilder)(ruleBuilderDispatch);
exports.getRuleBuilderForRule = getRuleBuilderForRule;

function buildLineRule(rule) {
  return (0, _atom.buildRule)(getRuleBuilderForRule, rule);
}

function buildLabelRule(valueFinder) {
  var label = valueFinder("labelText");
  var color = valueFinder("colorText");
  return {
    label: label,
    color: color
  };
}

function combineLabelRules() {
  var labelRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  // okay, first thing we do is we peel out the first date and the labelRule function
  // then we stuff those into an array sorted by the nextDate
  if (labelRules.length === 0) {
    return {};
  }

  var idx = 0;
  return function () {
    return labelRules[idx++ % labelRules.length];
  };
}